import type { ThemeConfig } from 'antd';

const inputSize = 18;
const config: ThemeConfig = {
  components: {
    Input: {
      fontSize: inputSize,
      fontSizeLG: inputSize,
    },
    DatePicker: {
      fontSize: inputSize,
      fontSizeIcon: inputSize,
    },
    Select: {
      fontSize: inputSize,
      fontSizeIcon: inputSize,
    },
    Checkbox: {
      borderRadiusSM: 0,
      colorBorder: '#a5a5a5',
      colorText: '#a5a5a5',
    },
    Pagination: {
      colorBgContainer: 'transparent',
      colorText: '#005dac',
      colorPrimary: '#000000',
      colorPrimaryHover: '#000000',
      lineWidth: 0,
    },
    Segmented: {
      controlHeight: 40,
      controlPaddingHorizontal: 20,
      marginSM: 10,
      borderRadiusSM: 16,
      itemColor: '#a5a5a5',
      itemSelectedBg: '#005dac',
      itemSelectedColor: '#ffffff',
      itemHoverColor: '#a5a5a5',
    },
    Button: {
      colorPrimaryHover: '#ffffff',
      colorPrimaryActive: '#ffffff',
      colorTextDisabled: '#ffffff',
      defaultHoverColor: '#4096ff',
      defaultHoverBorderColor: '#4096ff',
    },
  },
};

export default config;
